import {
	ACCESS_ROUTE,
	ADDITIONAL_INFO,
	CAREER_HISTORY_LIST,
	COMPANY_STATUS_KEY_TYPE,
	EDUCATION_INFO,
	ETC_INFO,
	FAMILY_RELATIONSHIPS,
	FINANCIAL_CONSULTANT,
	INSURANCE_EXPERIENCE,
	OPENING_KEY_TYPE,
	PERSONAL_INFO,
	REGISTER_CORPORATION_INFO,
	REGISTER_MANAGER,
	TAX_ACCOUNTANT_REGISTRATION_INFO
} from "@/shared/model";
import * as z from "zod";

const schema = z.object({
	basicInformation: z.object({
		areaBlock: z.boolean().nullable().default(false),
		name: z.string().nullable(),
		nameBeforeModified: z.string().nullable(),
		companyStatus: COMPANY_STATUS_KEY_TYPE,
		status: OPENING_KEY_TYPE,
		manager: REGISTER_MANAGER.nullable()
	}),
	certificate: z.array(z.string()).nullable(),
	corporationInformation: REGISTER_CORPORATION_INFO.nullable(),
	insuranceExperienceInformation: INSURANCE_EXPERIENCE.nullable(),
	accessRouteInformation: ACCESS_ROUTE.nullable(),
	gStarClubs: z.array(z.string()).optional().default([]),
	familyInformation: FAMILY_RELATIONSHIPS.nullable(),
	personalInformation: PERSONAL_INFO.nullable(),
	additionalInformation: ADDITIONAL_INFO.nullable(),
	fcRegistrationInformations: FINANCIAL_CONSULTANT.nullable(),
	etcInformation: ETC_INFO.nullable(),
	careerInformations: CAREER_HISTORY_LIST.nullable(),
	educationInformations: EDUCATION_INFO.nullable(),
	registrationInformation: TAX_ACCOUNTANT_REGISTRATION_INFO.nullable(),
	manualUpdateDate: z.string().nullable()
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountantRegisterV2Request = { schema, model };
export type ITaxAccountantRegisterV2Request = z.infer<typeof TaxAccountantRegisterV2Request.model>;

export const DEFAULT_TAX_ACCOUNTANT_REGISTER_V2_REQUEST: ITaxAccountantRegisterV2Request = {
	basicInformation: {
		areaBlock: false,
		manager: null,
		name: "",
		nameBeforeModified: "",
		companyStatus: "UNKNOWN",
		status: "UNKNOWN"
	},
	certificate: [],
	corporationInformation: null,
	insuranceExperienceInformation: null,
	accessRouteInformation: null,
	gStarClubs: [],
	familyInformation: null,
	personalInformation: {
		genderCode: null,
		gender: "UNKNOWN",
		birthday: null,
		realBirthday: null,
		birthdayType: null,
		birthplace: null,
		phone: null,
		email: null,
		religion: null,
		bloodType: null,
		twelveZodiacAnimal: null,
		golfPreference: null,
		golfHandicaps: [],
		hobby: "",
		hobbies: []
	},
	additionalInformation: null,
	fcRegistrationInformations: [],
	etcInformation: null,
	careerInformations: [],
	educationInformations: [],
	registrationInformation: null,
	manualUpdateDate: ""
};
